import React, { useState, useContext } from "react";
import Header from "../Header";
import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, 
  TextField, Paper, Box, Button, Typography } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useParams, useNavigate } from "react-router-dom";
import { AppContext } from "../../App";

export default function PromoterLogin() {

  const { setEventDetails } = useContext(AppContext)

  const [inputEventId, setInputEventId] = useState("")

  const [idError, setIdError] = useState(false)

  const navigate = useNavigate()

  const handleChange = (e) => {
    setInputEventId(
      e.target.value
    )
  };

  async function checkEventId(e){
    e.preventDefault()

    const response = await fetch(`https://the-paper-pusher.herokuapp.com/checkEventId/${inputEventId}`)
    if (!response.ok) {
      const message = `An error occurred: ${response.statusText}`
      window.alert(message)
      return
    }

    const enteredIdDetails = await response.json()
    if(enteredIdDetails === null){
      setIdError(true)
    } else {
      sessionStorage.setItem('eventID', inputEventId)
      setEventDetails(enteredIdDetails)
      navigate("/promoter/home")
    }
  }

  return (
    <div className="register-form">
      <Header />
      <Paper elevation={3} sx={{maxWidth: 820, margin: '0 auto'}}>
        <h3 className="form-heading">Promoter Log in</h3>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', maxWidth: 700, margin: '0 auto' , justifyContent: 'center'}}>
          <div className="register-inputs">
            <TextField
              required
              sx={{marginBottom: 2}}
              name="eventId"
              id="outlined-required"
              label="Event ID"
              onChange={handleChange}
              error={idError}
              />
          </div>
        </Box>
        <Button onClick={(e) => checkEventId(e)}>Login</Button>
        {idError ? 
        <p>*Event ID not valid</p> :
        null}
      </Paper>
    </div>
  ) 
}